import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";


export const Contact = () =>{
    const formInitialDetails = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
    }
    const [result, setResult] = useState("");
    
    const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);
    formData.append("access_key", "7869170e-7fc6-4c74-8f62-1d43219e77d4");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();
    if (data.success) {
      setResult("Message Sent Successfully!");
      event.target.reset();
    } else {
      setResult("Message failed please contact me through linkedin.");
    }
    };


    return(
        <section className="contact" id="connect">
            <Container>
                <Row className="align-items-center">
                    <Col>
                        <Col md={6}>
                            <h2>Get in Touch</h2>
                            <form onSubmit={onSubmit}>
                                <Row>
                                    <Col sm={6} className="px-1">
                                        <input type="text" placeholder= "First name" name="firstname" required/>
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input type="text" placeholder= "Last name" name="lastname" required/>
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input type="email" placeholder="Email Address" name="email" />
                                    </Col>
                                    <Col sm={6} className="px-1">
                                        <input type="phone" placeholder="+1 (555) 1234-567" name="phone"/>
                                    </Col>
                                    <Col className="px-1">
                                        <textarea row = "6" name="message" placeholder="Message"required/>
                                        <button type="submit"><span>Send</span></button>
                                    </Col>
                                </Row>
                            </form>
                        </Col>
                        <h4 className="formResult">{result}</h4>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}